import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { setOverlayVisible } from "../../../redux/actions/overlay";
import Messages from "../../messages/Messages";

const MessagesOverlay = () => {
  const dispatch = useDispatch();
  const hideModal = () => {
    dispatch(
      setOverlayVisible({
        visible: false,
        overlayType: "subscribe",
      }),
    );
  };

  return (
    <div className="messages-overlay">
      <div className="overlay_contents">
        <CloseIcon className="overlay_close-icon" onClick={hideModal} />
        <Messages />
      </div>
    </div>
  );
};

export default MessagesOverlay;
